import styled from "styled-components";

import Checkbox from "ds/Checkbox";

const Layout = styled(Checkbox)`
  margin-bottom: 0;
  margin-right: 12px;

  [role="label"] {
    display: none;
  }
`;

export default Layout;
